module.exports = __webpack_public_path__ + "Sony-6e9ef00f.webp";